var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row flex-wrap"},[_c('tips',{staticClass:"sm:w-1/3 md:w-1/4"}),(_vm.item)?_c('CurrentParcours',{staticClass:"sm:w-2/3 md:w-3/4",attrs:{"item":_vm.item}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }